import { User } from './types';
import { useCartState } from './cart';

/**
 * The signed-in visitor, or null.
 *
 * Its own hook, the way headless_jshop has one, so a component that wants the user does
 * not have to know a cart exists. It is not its own *source*, though, and cannot be:
 * headless does the same thing —
 *
 *     const { cart } = useCart();
 *     useSWR<User | null>(cart ? ['api.customer.get'] : null, fetcher)
 *
 * — because UserController extends CartAwareController and calls assertCart(). Without
 * a cart there is no user to ask for. The provider handles that ordering; this is just
 * the door onto it.
 *
 * Asynchronous in the same way the cart is: `loaded` separates "not yet" from "nobody
 * is signed in".
 */
export function useUser(): { user: User | null; loaded: boolean } {
  const { user, loaded } = useCartState();

  return { user, loaded };
}

export default useUser;
